import { render, staticRenderFns } from "./DocumentsTemplates.vue?vue&type=template&id=2192a9ea&scoped=true"
import script from "./DocumentsTemplates.vue?vue&type=script&lang=js"
export * from "./DocumentsTemplates.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTemplates.vue?vue&type=style&index=0&id=2192a9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192a9ea",
  null
  
)

export default component.exports